// extracted by mini-css-extract-plugin
export default {"notification":"AppVersion_notification__edIJk","notificationIcon":"AppVersion_notificationIcon__hdwsT","notificationAction":"AppVersion_notificationAction__PEveF"};